import React, { useRef } from "react";
import { Helmet } from "react-helmet";

import Layout from "../../components/Layout";

import HomeSection01 from "../../components/sections/homeSections/HomeSection01";
import HomeSection02_3 from "../../components/sections/homeSections/HomeSection02-3";
import HomeSection03_1 from "../../components/sections/homeSections/HomeSection03-1";
import Estimate_solid from "../../components/sections/homeSections/Estimate_solid";
import FloatingButtons from "../../components/sections/homeSections/FloatingButtons";
import PluugSection from "../../components/sections/homeSections/PluugSection";
import LastSection from "../../components/sections/homeSections/LastSection";


interface HomeProps { }

const Home: React.FC<HomeProps> = () => {
  const pluugRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <Layout>
        <Helmet>
          <title>Slogup - Home</title>
        </Helmet>
        {/* WHAT’S UP?... */}
        <HomeSection01 />
        {/* 슬로그업은 도전과 창조로 IT가 필요한 곳에... */}
        <HomeSection03_1 />
        {/* OutSourcing Service */}
        <HomeSection02_3 />
        {/* Valueup Service */}
        <Estimate_solid />

        <LastSection />

        <PluugSection ref={pluugRef} />

        <FloatingButtons />
      </Layout>
    </>
  );
};

export default Home;
